import type { DataChartModel } from "./dataChart";

const colors = ["#fff0a6", "#ffcf70", "#ffad42", "#ff8834", "#ef5829", "#cf2925", "#a50f15"];

/** Size the matrix along both axes without stretching or shrinking its text. */
export function HeatmapChart({ model, title }: { model: DataChartModel; title: string }) {
	const { columns, rows } = model.heatmap!;
	const maximum = Math.max(1, ...model.data.map((cell) => Number(cell.value)));
	return (
		<div
			role="figure"
			aria-label={title}
			style={{
				flex: "1 1 auto",
				height: 240,
				minHeight: 0,
				minWidth: 0,
				overflow: "auto",
				padding: "8px 12px 12px",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					height: "100%",
					minHeight: 180,
					minWidth: 360,
					gap: 10,
				}}
			>
				<div
					style={{
						display: "grid",
						gridTemplateColumns: `28px repeat(${columns.length}, minmax(0, 1fr))`,
						gridTemplateRows: `22px repeat(${rows.length}, minmax(0, 1fr))`,
						gap: 4,
						flex: "1 1 0",
						minHeight: 0,
						fontSize: 11,
					}}
				>
					{columns.map((column, i) => (
						<span
							key={i}
							style={{ gridColumn: i + 2, gridRow: 1, textAlign: "center", alignSelf: "center" }}
						>
							{column}
						</span>
					))}
					{rows.map((row, i) => (
						<span key={i} style={{ gridColumn: 1, gridRow: i + 2, alignSelf: "center" }}>
							{row}
						</span>
					))}
					{model.data.map((cell, i) => {
						const value = Number(cell.value);
						const description = `${rows[Number(cell.y)]}, ${columns[Number(cell.x)]}: Total ${value.toLocaleString()}${cell.average == null ? "" : `; Avg ${Number(cell.average).toLocaleString()}`}`;
						return (
							<div
								key={i}
								style={{
									gridColumn: Number(cell.x) + 2,
									gridRow: Number(cell.y) + 2,
									borderRadius: 4,
									background:
										colors[
											Math.min(
												colors.length - 1,
												Math.floor((value / maximum) * (colors.length - 1)),
											)
										],
								}}
								tabIndex={0}
								role="img"
								aria-label={description}
								title={description}
							/>
						);
					})}
				</div>
				<div
					aria-label={`Sales scale: low to ${maximum.toLocaleString()}`}
					style={{
						display: "flex",
						alignItems: "center",
						gap: 6,
						paddingLeft: 32,
						paddingRight: 20,
						fontSize: 10,
						flexShrink: 0,
					}}
				>
					<span>Low</span>
					<div style={{ display: "flex" }}>
						{colors.map((color) => (
							<span key={color} style={{ width: 14, height: 10, background: color }} />
						))}
					</div>
					<span>High ({maximum.toLocaleString()})</span>
				</div>
			</div>
		</div>
	);
}
